var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EChart',{attrs:{"card":"","header":_vm.$t('finance.yourPayouts'),"loading":_vm.loading,"error":_vm.errorMessage,"height":"380","type":"bar","options":_vm.chartOptions},scopedSlots:_vm._u([{key:"nav",fn:function(){return [_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('finance.totalMonthlyPayouts')))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }